import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      step: '01',
      title: 'Connect Your AWS Account',
      description: 'Securely connect your AWS account using IAM roles with minimal permissions. Our setup takes less than 5 minutes.',
      image: 'AWS Connection Setup (600x400px)'
    },
    {
      step: '02',
      title: 'Deploy FinOps Plugins',
      description: 'Choose from our library of automation plugins and deploy them directly to your AWS environment. Each plugin is tailored for specific cost optimization scenarios.',
      image: 'Plugin Deployment Interface (600x400px)'
    },
    {
      step: '03',
      title: 'Monitor & Optimize',
      description: 'Watch as your dashboard populates with real-time cost data and automated optimizations begin working. Get insights and recommendations to further improve your FinOps practices.',
      image: 'Dashboard Analytics View (600x400px)'
    }
  ];

  return (
    <section id="how-it-works" className="how-it-works">
      <div className="container">
        <div className="section-header text-center">
          <h2>How Finoptic Works</h2>
          <p>Get started with AWS cost optimization in three simple steps</p>
        </div>
        
        <div className="steps">
          {steps.map((step, index) => (
            <div key={index} className={`step ${index % 2 === 1 ? 'step-reverse' : ''}`}>
              <div className="step-content">
                <div className="step-number">{step.step}</div>
                <h3>{step.title}</h3>
                <p>{step.description}</p>
              </div>
              <div className="step-visual">
                <div className="placeholder-image">
                  {step.image}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;